import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';

/**
 * PublicRoute component that redirects logged-in users away from auth pages.
 * It derives the auth state directly from localStorage so the latest token
 * value is available on first render (no stale query cache required).
 */
const PublicRoute = ({ children }) => {
  const [hasToken, setHasToken] = useState(() => !!localStorage.getItem('token'));

  useEffect(() => {
    const updateAuthState = () => {
      setHasToken(!!localStorage.getItem('token'));
    };

    // Listen for manual dispatches (same-tab) and cross-tab storage events
    window.addEventListener('localStorageChange', updateAuthState);
    window.addEventListener('storage', updateAuthState);

    // Run once on mount in case token changed before listeners were attached
    updateAuthState();

    return () => {
      window.removeEventListener('localStorageChange', updateAuthState);
      window.removeEventListener('storage', updateAuthState);
    };
  }, []);

  if (hasToken) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default PublicRoute;

